import { render, staticRenderFns } from "./PrintBillK80.vue?vue&type=template&id=bd034698&scoped=true&"
import script from "./PrintBillK80.vue?vue&type=script&lang=js&"
export * from "./PrintBillK80.vue?vue&type=script&lang=js&"
import style0 from "./PrintBillK80.vue?vue&type=style&index=0&id=bd034698&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd034698",
  null
  
)

export default component.exports